import React, { useState } from 'react';
import styles from '../styles/components/_FAQ.module.scss';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className={`${styles.faqItem} ${isOpen ? styles.open : ''}`}>
      <button 
        className={styles.faqQuestion}
        onClick={onClick}
        aria-expanded={isOpen}
      >
        <span>{question}</span>
        <span className={styles.icon}></span>
      </button>
      <div className={styles.faqAnswer} aria-hidden={!isOpen}>
        <div className={styles.answerContent}>
          <p>{answer}</p>
        </div>
      </div>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', label: 'Toutes les questions' },
    { id: 'info', label: 'Informations générales' },
    { id: 'tickets', label: 'Billetterie' },
    { id: 'access', label: 'Accès & Transport' },
    { id: 'rules', label: 'Règlement' }
  ];

  const faqData = [
    {
      "question": "Où se situe le Poney Club ?",
      "answer": "Le Poney Club est situé sur le parking P3 de l'aéroport de Toulouse-Blagnac.",
      "category": "info"
    },
    {
      "question": "Quand débute la saison 2025 ?",
      "answer": "La saison 2025 du Poney Club débutera le 11 juin 2025.",
      "category": "info"
    },
    {
      "question": "Quels sont les horaires d'ouverture ?",
      "answer": "Le Poney Club ouvre généralement ses portes à partir de 18h. Pour certains événements, le Poney Club peut ouvrir plus tôt. Veuillez vérifier l'heure spécifique de votre événement dans la billetterie.",
      "category": "info"
    },
    {
      "question": "Comment acheter des billets ?",
      "answer": "Les billets sont en vente sur notre site ou directement sur le site de notre partenaire Xceed.",
      "category": "tickets"
    },
    {
      "question": "Comment se rendre au Poney Club ?",
      "answer": "En voiture : suivez les indications pour l'aéroport puis P3. Le parking est gratuit sur présentation de votre billet. Vous pouvez également utiliser la navette Poney Club depuis le métro Barrière de Paris (billet à acheter en complément de votre billet sur la billetterie). Attention, la ligne T2 du tramway ne dessert pas le site.",
      "category": "access"
    },
    {
      "question": "Y a-t-il un parking ?",
      "answer": "Oui, un parking gratuit et surveillé est disponible sur présentation de votre billet. Veuillez noter que vous ne pouvez pas laisser votre voiture avant et après l'événement.",
      "category": "access"
    },
    {
      "question": "Y a-t-il un âge minimum pour participer aux événements ?",
      "answer": "Les mineurs en dessous de 16 ans doivent être obligatoirement accompagnés de leurs parents.",
      "category": "rules"
    },
    {
      "question": "Que peut-on apporter sur le site ?",
      "answer": "Pour des raisons de sécurité, les sacs de grande taille, les bouteilles en verre, l'alcool et tout objet dangereux sont interdits.",
      "category": "rules"
    },
    {
      "question": "Peut-on sortir et rentrer durant l'événement ?",
      "answer": "Non, toute sortie est définitive.",
      "category": "rules"
    }
  ];
  
  const handleClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const filteredFaq = activeCategory === 'all'
    ? faqData
    : faqData.filter(item => item.category === activeCategory);

  return (
    <div className={styles.faqSection}>
      <h2 className={styles.faqTitle}>Foire Aux Questions</h2>
      
      <div className={styles.categoryTabs}>
        {categories.map(category => (
          <button
            key={category.id}
            className={`${styles.categoryTab} ${activeCategory === category.id ? styles.active : ''}`}
            onClick={() => {
              setActiveCategory(category.id);
              setOpenIndex(null);
            }}
          >
            {category.label}
          </button>
        ))}
      </div>
      
      <div className={styles.faqContainer}>
        {filteredFaq.length > 0 ? (
          filteredFaq.map((item, index) => (
            <FAQItem 
              key={index} 
              question={item.question} 
              answer={item.answer}
              isOpen={openIndex === index}
              onClick={() => handleClick(index)}
            />
          ))
        ) : (
          <p className={styles.noResults}>Aucune question dans cette catégorie</p>
        )}
      </div>
    </div>
  );
};

export default FAQ;
